import { FC } from 'react'

import { VStack } from '@revolut-internal/ui-kit'
import { Table } from '@revolut-internal/ui-kit-table'

import { DEFAULT_LINE_CHART_HEIGHT } from 'consts/chart'

import { LineChartSkeleton } from '../LineChart/LineChartSkeleton'

type ChartTableSkeletonProps = {
  chartHeight?: number
}

export const ChartTableSkeleton: FC<ChartTableSkeletonProps> = ({
  chartHeight = DEFAULT_LINE_CHART_HEIGHT,
}) => (
  <VStack space="s-32">
    <LineChartSkeleton height={chartHeight} />
    <Table loadingState="pending" data={[]} columns={[]} />
  </VStack>
)
